import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SortingDescendingIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M8.7071 9.58564V2.99985H6.7071V9.58563L5.41422 8.29274L4 9.70695L7.7071 13.4141L11.4142 9.70695L10 8.29274L8.7071 9.58564Z"
        fill="#0050B3"
        className={styles.interactiveColor}
      />
    </Icon>
  )
}
